export default Object.freeze({
  ALGINATE: 'Alginate',
  SILICONE: 'Silicone',
});
